import CustomisedButton from '../../../../components/button/button';
import CustomisedCardBullet from '../../../../components/card/cardBullet';
import { useEffect, useState } from 'react';
import InquiryFeeSkeleton from './inquiryFeeSkeleton';
import { useMutation, useQueryClient } from 'react-query';
import { TotalInquiryRequest, IInquiryResponse, IInquiryResult, Inquiries } from '../../../../models/inquiry.model';
import { getrequiredInquiryList, TotalInquiry } from '../../../../services/inquiry.service';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../../../redux/headerTitle/headerTitleSlice';
import { IInquiry } from '../IInquriry';
import { changeRouteType } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { v4 as uuid } from 'uuid';
import { INQUIRY_REQUIRED_OTP, INQUIRY_RESULT } from '../../../../config/cacheKey';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { ApiResultModel } from '../../../../models/common.model';
const InquiryFee = ({ referenceKey, setInnerState, setStep }: IInquiry) => {
    const { setHeader } = useAppBar();
    const [loading, setLoading] = useState(true);
    const [inquirtList, setInquirtList] = useState<IInquiryResult[]>();
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const dispatch = useDispatch();
    const handlePay = () => {
        const request = {} as TotalInquiryRequest;
        request.referenceKey = referenceKey!;
        InquiryValidationOTPMutation(request);
        //todo add service pay 
        // setStep(uuid);
        // setInnerState('otp')
    }
    useEffect(() => {

        setHeader('پرداخت هزینه استعلام ها', 'inquiry')
        setTimeout(() => setLoading(false), 2000);
        GetRequiredInquiryListMutate({
            referenceKey: referenceKey!,
        });
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
    }, []);
    const queryClient = useQueryClient();
    const { mutateAsync: InquiryValidationOTPMutation, isLoading } = useMutation(TotalInquiry, {
        onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
            if (data) {
                if (data.data.requiredOtpValidation) {
                    setInnerState!('otp');
                    queryClient.setQueryData(INQUIRY_REQUIRED_OTP, data.data.requiredOtpValidation);
                }
                else if (data.data.inquiries.length > 0) {
                    setInnerState!('inquiryResult')
                    queryClient.setQueryData(INQUIRY_RESULT, data.data.inquiries);
                }
                else {
                    setStep(uuid);
                }

            }
        },
        onError: () => { },
    });
    const { mutate: GetRequiredInquiryListMutate, isLoading: GetRequiredInquiryListLoding } = useMutation(
        getrequiredInquiryList,
        {

            onSuccess: (data: IInquiryResponse) => {
                if (data) {
                    setInquirtList(data.inquiries);
                    setTotalAmount(data.totalAmount);
                }
            },
        }
    );
    if (GetRequiredInquiryListLoding) {
        return <InquiryFeeSkeleton />;
    }

    return (
        <div className="container-height-drawer">
            <div className=" primaryColorLight-900 content-container">
                <div className='drawer-content'>
                    <p
                        className="anjomanRegular"
                        style={{
                            paddingLeft: '30px',
                            paddingRight: '6px',
                            paddingTop: '10px',
                            fontSize: '14px',
                        }}
                    >
                        {totalAmount > 0 ? 'جهت انجام استعلامات زیر،  نسبت به پرداخت هزینه اقدام قرمایید.' : 'استعلامات مورد نیاز :'}

                    </p>
                    {inquirtList?.map((item, index) => (
                        <CustomisedCardBullet firstTitle={item.inquiryTypeTitle} key={index} />
                    ))}
                </div>
                <div className="py-5">
                    <CustomisedButton
                        title={`${totalAmount > 0 ? 'پرداخت مبلغ' + ' (' + totalAmount?.toLocaleString() + ' ریال)' : 'استعلام'}`}
                        disable={false}
                        onClick={handlePay}
                        type="submit"
                    />
                </div>
            </div>
        </div>
    );
};

export default InquiryFee;
